export const AGENT_LIST_PAGE_SIZE = 50;
/**
 * Returns one page of `items` (1-based page). Empty list → page 1, pageCount 1.
 */
export function pageSlice(items, page, pageSize = AGENT_LIST_PAGE_SIZE) {
    const total = items.length;
    const size = Math.max(1, Math.floor(pageSize));
    const pageCount = Math.max(1, Math.ceil(total / size));
    const safePage = Math.min(Math.max(1, Math.floor(page)), pageCount);
    const start = (safePage - 1) * size;
    const slice = items.slice(start, start + size);
    const from = total === 0 ? 0 : start + 1;
    const to = total === 0 ? 0 : start + slice.length;
    return {
        items: slice,
        page: safePage,
        pageCount,
        from,
        to,
        total,
    };
}
